import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {NewsTile as NewsTile_} from '@/src/entities/news'

import {Link} from '@/src/shared/ui/link'

export const Wrapper = styled.div``

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 27px;

  flex-direction: column;

  @media ${media.md} {
    flex-direction: row;
  }
`

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  gap: 5px;

  @media ${media.md} {
    gap: 20px;
  }
`

export const Pagination = styled.div`
  width: 100%;

  &.ant-pagination {
    justify-content: center;
    flex: 1;

    .ant-pagination-item {
      background-color: transparent;
      color: ${theme.colors.textDark};
    }

    .ant-pagination-item-active {
      background-color: ${theme.colors.primary};
      color: ${theme.colors.text};
    }

    .ant-pagination-next,
    .ant-pagination-prev {
      color: ${theme.colors.white};

      svg {
        fill: ${theme.colors.white};
      }
    }
  }

  @media ${media.md} {
    &.ant-pagination {
      justify-content: flex-end;
    }
  }
`

export const TagLink = styled(Link)`
  [data-dark='true'] & {
    color: ${theme.colors.textDark};

    & span {
      border-bottom: solid 1px ${theme.colors.textDark};
    }
  }
`

const ActiveTagStyle = css`
  color: ${theme.colors.textLink};

  background: ${theme.colors.primary};

  span {
    color: ${theme.colors.textLink};
    border-color: ${theme.colors.textLink};
  }
`

export const Tag = styled.div<{$active?: boolean}>`
  & ${TagLink} {
    font-weight: 300;
    padding: 6px 12px;
    border-radius: 5px;

    ${props => props.$active && ActiveTagStyle}
    &:hover {
      ${ActiveTagStyle}

      span {
        ${ActiveTagStyle}
      }
    }
  }
`

export const Articles = styled.div`
  padding: 27px 0;

  display: flex;
  flex-direction: column;
  gap: 10px;

  @media ${media.md} {
    gap: 25px;
  }

  @media ${media.lg} {
    gap: 38px;
  }
`

export const ArticleContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;

  & > * {
    flex: 1;
  }

  @media ${media.md} {
    gap: 25px;

    flex-direction: row;
  }

  @media ${media.lg} {
    gap: 38px;
  }
`

export const NewsTile = styled(NewsTile_)``

export const NewsTileTitle = styled(Link)`
  margin-top: 3px;

  font-size: 1.875rem;
  font-weight: 450;

  [data-dark='true'] & {
    color: ${theme.colors.white};
  }

  & span {
    display: unset;
    white-space: normal;
    text-decoration: underline;
    text-underline-offset: 4px;
    line-height: 1.5;
    //border-bottom: ${theme.colors.titleBorder};
  }

  [data-dark='true'] &:hover {
    color: ${theme.colors.primary};

    & span {
      //border-bottom-color: ${theme.colors.primary};
    }
  }
`

export const ArticleContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: 15px;
`
export const NewsTileDescription = styled.div`
  margin-top: 5px;

  @media ${media.md} {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media ${media.lg} {
    -webkit-line-clamp: 15;
  }
`

export const Alert = styled.div`
  border: solid 1px ${theme.colors.primary};

  & .ant-alert-description {
    color: ${theme.colors.primary};
  }

  background: transparent;
`
